module.exports = __webpack_public_path__ + "img/cuban-cocktails-100-classic-modern-drinks.b6c64466.jpg";